import { useTheme } from "@emotion/react";
import { Dialog, DialogContent, DialogTitle, Icon, IconButton, useMediaQuery } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import React from "react";

const OcfDetailsModal = ({ open, onClose, data }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const SectionCard = ({ title, children }) => (
    <MDBox
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 2,
        background: "transparent",
      }}
    >
      <MDTypography variant="h6" mb={1}>
        {title}
      </MDTypography>
      {children}
    </MDBox>
  );

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: darkMode ? "#1a2035" : "#fff", // same as ConfigProvider example
          color: darkMode ? "#fff" : "#000",
          borderRadius: 2,
        },
      }}
    >
      {/* HEADER */}
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          color: darkMode ? "#fff" : "#000",
          backgroundColor: darkMode ? "#1f2937" : "#f5f5f5", // subtle header background
          borderBottom: `1px solid ${darkMode ? "#475894" : "#d9d9d9"}`,
        }}
      >
        <MDTypography variant="h5">Ocf Details</MDTypography>

        <IconButton onClick={onClose} sx={{ color: darkMode ? "#fff" : "#000" }}>
          <Icon>close</Icon>
        </IconButton>
      </DialogTitle>

      {/* CONTENT */}
      <DialogContent dividers>
        {data ? (
          <MDBox display="flex" flexDirection="column" gap={3}>
            {/* 🔥 HEADER SUMMARY */}
            <MDBox display="flex" justifyContent="space-between" flexWrap="wrap" gap={2}>
              <MDTypography variant="h6">OCF ID: {data?.ocfDisplayId}</MDTypography>

              <MDTypography color="info">Status: {data?.ocfStatus}</MDTypography>

              <MDTypography>Owner: {data?.ownedBy}</MDTypography>
            </MDBox>

            {/* 👤 APPLICANT */}
            <SectionCard title="Applicant Details">
              <MDBox display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
                <span>Name: {data?.applicant?.name}</span>
                <span>Gender: {data?.applicant?.gender}</span>
                <span>Aadhar: {data?.applicant?.aadhar}</span>
                <span>Care Of: {data?.applicant?.careOfName}</span>
              </MDBox>
            </SectionCard>

            {/* 👥 CO-APPLICANT */}
            <SectionCard title="Co-Applicant">
              <MDBox display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
                <span>Name: {data?.coApplicant?.name}</span>
                <span>Relation: {data?.coApplicant?.relationWithApplicant}</span>
                <span>Gender: {data?.coApplicant?.gender}</span>
                <span>Aadhar: {data?.coApplicant?.aadhar}</span>
              </MDBox>
            </SectionCard>

            {/* 🏠 PROPERTY */}
            <SectionCard title="Property Details">
              <MDBox display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
                <span>Name: {data?.propertyDetails?.name}</span>
                <span>Type: {data?.propertyDetails?.typeSize?.type}</span>
                <span>Size: {data?.propertyDetails?.typeSize?.size}</span>
                <span>Plan: {data?.propertyDetails?.paymentPlan}</span>
              </MDBox>
            </SectionCard>

            {/* 💰 COSTING */}
            <SectionCard title="Costing">
              <MDBox display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
                <span>Total BSP: ₹{data?.costing?.totalBsp}</span>
                <span>Property Price: ₹{data?.costing?.propertyPrice}</span>
                <span>Revenue: ₹{data?.costing?.netRevenue}</span>
                <span>Commission: ₹{data?.costing?.totalCommission}</span>
              </MDBox>
            </SectionCard>

            {/* 📄 STATUS / REMARKS */}
            <SectionCard title="Remarks">
              <MDTypography>CRM: {data?.crmRemark || "-"}</MDTypography>
            </SectionCard>
          </MDBox>
        ) : (
          <MDTypography>No data</MDTypography>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default OcfDetailsModal;





